/**
 * The only place build-time mode and URLs are read. Everything else imports from here.
 *
 * - `VITE_APP_MODE=demo` builds the sandbox: no backend, every API call is answered in the browser
 *   from recorded sample data (see `src/demo/`). Anything else (including unset) is the live app.
 * - `VITE_MARKETING_URL` (optional) is where the demo banner links back to.
 *
 * `IS_DEMO` is a build-time constant, so the live bundle drops the demo engine entirely.
 */
export type AppMode = 'demo' | 'live';

export const APP_MODE: AppMode = import.meta.env.VITE_APP_MODE === 'demo' ? 'demo' : 'live';

export const IS_DEMO: boolean = import.meta.env.VITE_APP_MODE === 'demo';

function optionalUrl(value: unknown): string | undefined {
  return typeof value === 'string' && value.trim() ? value.trim() : undefined;
}

export const MARKETING_URL: string | undefined = optionalUrl(import.meta.env.VITE_MARKETING_URL);

/** Only meaningful in `live`; the demo never makes a network request. */
export const API_URL: string | undefined = optionalUrl(import.meta.env.VITE_API_URL);
